import React, {CSSProperties, ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import {
	Annotation,
	BorderStyle,
	Markup,
	MetadataRectangle
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class CircleAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		let annotationStyle: CSSProperties = {
			opacity: FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100,
			stroke: color,
			strokeLinejoin: "round"
		};

		if (FunctionHelper.exists(annotation.border)) {
			annotationStyle.fill = annotation.border!.interiorColor;
			annotationStyle.strokeWidth = annotation.border!.width!.toString();

			if (annotation.border!.style === BorderStyle.Dashed) {
				annotationStyle.strokeDasharray = JSON.parse(annotation.border!.dashPattern!).join(",");
			}
		}

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries} popupCreator={annotation.markup?.creator}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupContent={annotation.contents} popupColor={color}
								 creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				<svg xmlns={SVG_NAMESPACE}>
					<ellipse cx={rectBoundaries.width! / 2} cy={rectBoundaries.height! / 2}
							 rx={rectBoundaries.width! / 2} ry={rectBoundaries.height! / 2} style={annotationStyle}/>
				</svg>
			</AnnotationRectangle>
		);
	}
}